import { createApi } from "@reduxjs/toolkit/query/react";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { exopenApi } from "../../redux/api/exopenApi";
import { makeBaseQueryWithUnauthentication } from "../../redux/api/baseQuery";
import { eldvaktApiUrl } from "src/env.ts";

const TAGS = [
	"AiCompanyDomainSettings",
	"AiConversation",
	"AiMemory",
	"AiMessage",
	"AiModel",
	"AiPendingNotifications",
	"AiSkill",
	"AiUserOptIn",
	"AiUserSettings",
	"PushSubscription",
] as const;

const innerBaseQuery = makeBaseQueryWithUnauthentication({
	baseUrl: eldvaktApiUrl,
});

function errorNameMatches(
	error: FetchBaseQueryError | undefined,
	name: string,
): boolean {
	if (!error || error.status !== 403) {
		return false;
	}
	const data = error.data;
	return (
		typeof data === "object" &&
		data !== null &&
		"error" in data &&
		(data as { error: unknown }).error === name
	);
}

export const emptyEldvaktApi = createApi({
	reducerPath: "eldvaktApi",
	baseQuery: async (args, api, extraOptions) => {
		const result = await innerBaseQuery(args, api, extraOptions);
		if (errorNameMatches(result.error, "AiNotOptedInError")) {
			api.dispatch(emptyEldvaktApi.util.invalidateTags(["AiUserOptIn"]));
		}
		if (errorNameMatches(result.error, "MissingExopenAiAccessError")) {
			api.dispatch(exopenApi.util.invalidateTags(["CurrentUser"]));
		}
		return result;
	},
	tagTypes: TAGS,
	endpoints: () => ({}),
});
